/**
 * Experiment Constants
 *
 * This file contains constants used for A/B testing experiments across the HotPads web application.
 *
 * IMPORTANT: Ensure any updates or changes to these constants are reflected in:
 * - apps/hotpads-web/app/shared/experiments/index.ts
 *
 * Force Enrollment:
 * You can force enroll in either an experiment or control bucket by using special query parameters
 * with the VALUE (not the KEY) of this object:
 *
 * For example, if our constants look like this:
 * export default {
 *   HOTPADS_WEB_LISTED_BY_POSITION: 'HOTPADS_WEB_LISTING_AGENT_POSITION_2',
 * }
 *
 * To force enroll in control:
 * - https://hotpads.com?HPWEB_CONTROL=HOTPADS_WEB_LISTING_AGENT_POSITION_2
 *
 * To force enroll in experiment (any variant):
 * - https://hotpads.com?HPWEB_EXP=HOTPADS_WEB_LISTING_AGENT_POSITION_2
 *
 * To force enroll in specific variant:
 * - https://hotpads.com?HPWEB_EXP=HOTPADS_WEB_LISTING_AGENT_POSITION_2&HPWEB_TREATMENT=variant1
 * - https://hotpads.com?HPWEB_EXP=HOTPADS_WEB_LISTING_AGENT_POSITION_2&HPWEB_TREATMENT=variant2
 *
 * For complete A/B testing documentation, see: docs/features/ABTest.md
 */
export default {
  HOTPADS_WEB_HDP_AA_TEST: 'HOTPADS_WEB_AA_TEST_4',
  HOTPADS_WEB_LISTED_BY_POSITION: 'HOTPADS_WEB_LISTING_AGENT_POSITION_2',
  HOTPADS_WEB_DOT_MAP_TEST: 'HOTPADS_WEB_DOT_MAP_TEST',
  HOTPADS_WEB_APPLY_INSTANTLY: 'HOTPADS_WEB_APPLY_INSTANTLY',
  HOTPADS_WEB_NEW_UNITS: 'HOTPADS_WEB_NEW_UNITS',
  HOTPADS_WEB_PRICE_DROPS: 'HOTPADS_WEB_PRICE_DROPS',
  HOTPADS_WEB_APARTMENT_ONLY_LINKS: 'HOTPADS_WEB_APARTMENT_ONLY_LINKS',
  HOTPADS_WEB_CTA_COPY_TEST: 'HOTPADS_WEB_CTA_COPY_TEST',
  HOTPADS_WEB_POPULAR_PET_HDP_COLLECTIONS: 'HOTPADS_WEB_POPULAR_PET_HDP_COLLECTIONS',
  HOTPADS_WEB_NEXT_REWRITE: 'HOTPADS_WEB_NEXT_REWRITE',
};
